/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locallogin_Signingin2Inputs */

const en_locallogin_signingin2 = /** @type {(inputs: Locallogin_Signingin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minting session…`)
};

/**
* | output |
* | --- |
* | "Minting session…" |
*
* @param {Locallogin_Signingin2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const locallogin_signingin2 = /** @type {((inputs?: Locallogin_Signingin2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locallogin_Signingin2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_locallogin_signingin2(inputs)
});
export { locallogin_signingin2 as "localLogin_signingIn" }